import { PointerEvent as ReactPointerEvent } from "react";
import PdfCanvasPage from "./PdfCanvasPage";
import type { HesapSarkiSesKayitNotlarModel } from "../../../models/businessModels/HesapSarkiSesKayitNotlarModel";
import type {
    PdfCanvasColorMeaning,
    PdfCanvasEraserCursorState,
    PdfCanvasPageMeta,
    PdfCanvasToolType,
} from "./pdfCanvasTypes";

interface IPdfCanvasPagesContentProps {
    pdfContainerWidth: number,
    imageUrlList: { uri: string }[],
    readOnly: boolean,
    seciliArac: PdfCanvasToolType,
    seciliRenk: string,
    eraserCursor: PdfCanvasEraserCursorState,
    legendItems: PdfCanvasColorMeaning[],
    getPageMeta: (pageIndex: number) => PdfCanvasPageMeta | undefined,
    getPageNotlar: (pageIndex: number) => HesapSarkiSesKayitNotlarModel[],
    getDisplayBrushRadius: (pageIndex: number) => number,
    onDinleNot: (not: HesapSarkiSesKayitNotlarModel) => void,
    setImageRef: (pageIndex: number, el: HTMLImageElement | null) => void,
    setCanvasRef: (pageIndex: number, el: HTMLCanvasElement | null) => void,
    onPageImageLoaded: (pageIndex: number) => void,
    onPointerDown: (pageIndex: number, event: ReactPointerEvent<HTMLCanvasElement>) => void,
    onPointerMove: (pageIndex: number, event: ReactPointerEvent<HTMLCanvasElement>) => void,
    onPointerUp: () => void,
    onPointerLeave: (pageIndex: number) => void,
    onPointerEnter: (pageIndex: number) => void,
}

const PdfCanvasPagesContent = (props: IPdfCanvasPagesContentProps) => {
    const pageCount = props.imageUrlList.length;

    return <div style={{
        display: "flex",
        width: props.pdfContainerWidth,
        alignSelf: "center",
        flexFlow: "column",
        margin: "auto",
    }}>
        {props.imageUrlList.map((image, index) => {
            const pageMeta = props.getPageMeta(index);
            const readonlyMarkers = props.readOnly && pageMeta
                ? {
                    pageMeta,
                    pageNotlar: props.getPageNotlar(index),
                    legendItems: props.legendItems,
                    onDinleNot: props.onDinleNot,
                }
                : null;

            return <PdfCanvasPage
                key={`row_${index + 1}`}
                pageIndex={index}
                pageCount={pageCount}
                imageUri={image.uri}
                readOnly={props.readOnly}
                seciliArac={props.seciliArac}
                seciliRenk={props.seciliRenk}
                eraserCursor={props.eraserCursor}
                displayBrushRadius={props.getDisplayBrushRadius(index)}
                readonlyMarkers={readonlyMarkers}
                setImageRef={el => props.setImageRef(index, el)}
                setCanvasRef={el => props.setCanvasRef(index, el)}
                onImageLoad={() => props.onPageImageLoaded(index)}
                onPointerDown={e => props.onPointerDown(index, e)}
                onPointerMove={e => props.onPointerMove(index, e)}
                onPointerUp={props.onPointerUp}
                onPointerLeave={() => props.onPointerLeave(index)}
                onPointerEnter={() => props.onPointerEnter(index)}
            />;
        })}
    </div>;
};

export default PdfCanvasPagesContent;
